// routes
import listRoutes from '../../../routes/listRoutes'

export const navMenuList = {
	routine: listRoutes.myRoutine,
	services: listRoutes.yourServices,
	program: listRoutes.program,
	profile: listRoutes.profile
}

export const currentHome = navMenuList.services
